import { createUseStyles } from "react-jss";
import { ITheme } from "../../../../constants/theme";
import {
  BreakPointTablet,
  BreakPointMobile,
  BreakPointDesktop,
} from "../../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  // Desktop / tablet skeleton
  root: {
    display: "flex",
    alignItems: "stretch",
    gap: theme.spacing.space16,
    flexDirection: "column",
    paddingLeft: 90,
    paddingRight: 90,
    "@media (orientation: landscape)": {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    [BreakPointDesktop]: {
      display: "grid",
      gap: theme.spacing.space32,
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
    [BreakPointTablet]: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
  },
  column: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space32,
    width: "100%",
    [BreakPointTablet]: {
      flex: 1,
    },
    [BreakPointMobile]: {
      flex: 1,
    },
  },
  columnLeft: {
    [BreakPointDesktop]: {
      height: "100%",
      alignItems: "stretch",
    },
  },
  cardPlaceholder: {
    width: "100%",
    paddingBottom: "60%",
    height: 0,
    position: "relative",
    borderRadius: theme.radius.large,
    [BreakPointDesktop]: {
      height: "100%",
      paddingBottom: 0,
      flex: 1,
      minHeight: 0,
    },
  },
  featuredPlaceholder: {
    width: "100%",
    paddingBottom: "140%",
    height: 0,
    position: "relative",
    borderRadius: theme.radius.large,
    [BreakPointTablet]: {
      height: 402,
      paddingBottom: 0,
    },
    [BreakPointMobile]: {
      height: 360,
      paddingBottom: 0,
    },
  },
  skeletonInner: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: theme.radius.large,
  },

  // Mobile skeleton
  mobileRoot: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    width: "100%",
    padding: `0 ${theme.spacing.space16}px`,
  },
  greeting: {
    width: "40%",
    height: 28,
  },
  activityRow: {
    display: "flex",
    gap: theme.spacing.space12,
  },
  activityStat: {
    width: 167,
    minWidth: 167,
    height: 64,
    borderRadius: theme.radius.large,
    flexShrink: 0,
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
  },
  sectionTitle: {
    width: "50%",
    height: 28,
  },
  horizontalRow: {
    display: "flex",
    gap: theme.spacing.space12,
    overflow: "hidden",
  },
  // Continue Playing
  smallThumb: {
    width: 112,
    minWidth: 112,
    height: 150,
    position: "relative",
    borderRadius: theme.radius.large,
    flexShrink: 0,
  },
  // Featured row — large landscape
  featuredLandscape: {
    width: 310,
    minWidth: 310,
    height: 320,
    position: "relative",
    borderRadius: theme.radius.large,
    flexShrink: 0,
  },
  // Essential Pass t
  gameCard: {
    width: 160,
    minWidth: 160,
    height: 213,
    position: "relative",
    borderRadius: theme.radius.large,
    flexShrink: 0,
  },
}));
